// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3fQRw","input":"styles_input__qXg8L"};